<template>
  <v-card>
    <v-card-title>
      <span>
        Você irá enviar a mensagem para os clientes definidos como:
        <strong>{{ customer }}</strong></span>
    </v-card-title>
    <v-card-text>
      <form-group>
        <v-flex
          xs12
          md12
          lg12
        >
          <v-layout
            align-center
            justify-start
          >
            <input-checkbox
              v-model="sendSms"
              label="SMS"
            />
            <v-btn
              outline
              color="primary"
              @click="navigateTabMessage(2)"
            >
              <v-icon>
                edit
              </v-icon>
              Editar
            </v-btn>
          </v-layout>
          <v-layout
            align-center
            justify-start
          >
            <input-checkbox
              v-model="sendPush"
              label="PUSH"
            />
            <v-btn
              outline
              color="primary"
              @click="navigateTabMessage(0)"
            >
              <v-icon>
                edit
              </v-icon>
              Editar
            </v-btn>
          </v-layout>
          <v-layout
            align-center
            justify-start
          >
            <input-checkbox
              v-model="sendEmail"
              label="E-mail"
            />
            <v-btn
              outline
              color="primary"
              @click="navigateTabMessage(1)"
            >
              <v-icon>
                edit
              </v-icon>
              Editar
            </v-btn>
          </v-layout>
        </v-flex>
      </form-group>
    </v-card-text>
    <slot />
  </v-card>
</template>

<script>
import FormGroup from 'Support/layout/FormGroup.vue';
import InputCheckbox from 'Support/components/inputs/InputCheckbox.vue';

export default {
  name: 'CommunicationReviewContent',
  components: { FormGroup, InputCheckbox },
  computed: {
    payload() {
      return this.communicationData;
    },
    customer() {
      const option = this.payload.sendedOptions.find(
        i => i.value === this.payload.sendedOption,
      );

      if (!option) {
        return '';
      }

      return option.text;
    },
    proxy() {
      return (key, value) => {
        this.payload.setKeyData(key, value);
      };
    },
    sendSms: {
      get() {
        return this.payload.sendSms;
      },
      set(value) {
        this.proxy('sendSms', value);
      },
    },
    sendEmail: {
      get() {
        return this.payload.sendEmail;
      },
      set(value) {
        this.proxy('sendEmail', value);
      },
    },
    sendPush: {
      get() {
        return this.payload.sendPush;
      },
      set(value) {
        this.proxy('sendPush', value);
      },
    },
  },
  methods: {
    navigateTabMessage(tab) {
      this.$emit('handle-tab-message', tab);
    },
  },

  inject: {
    communicationData: {
      default() {
        return {};
      },
    },
  },
};
</script>
